import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { NavSidebar } from "./NavSidebar";

interface AppShellProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  children: React.ReactNode;
}

export function AppShell({ title, subtitle, onBack, children }: AppShellProps) {
  const nav = useNavigate();
  return (
    <div className="flex min-h-screen bg-background">
      <NavSidebar />
      <main className="flex-1 flex flex-col">
        <header className="border-b border-border px-6 py-4 flex items-center gap-3">
          {onBack && (
            <button
              onClick={onBack ?? (() => nav(-1))}
              className="text-muted-foreground hover:text-foreground"
              aria-label="Back"
            >
              <ArrowLeft className="h-5 w-5" />
            </button>
          )}
          <div>
            <h1 className="text-lg font-semibold text-foreground">{title}</h1>
            {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
          </div>
        </header>
        <div className="flex-1 px-6 py-5 overflow-auto">{children}</div>
      </main>
    </div>
  );
}
